export enum AdditionalSchemaKeys {
  watcher = '~watcher',
  takenBy = '~takenBy'
}
